window.OEMLogoSlider = (randomId) => {
  return {
    swiper: null,
    init() {
      setTimeout(() => {
        this.swiper = new Swiper("#swiper-" + randomId, {
          slidesPerView: 2,
          spaceBetween: 24,
          breakpoints: {
            640: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            768: {
              slidesPerView: 3,
            spaceBetween: 48,
            },
            1024: {
              slidesPerView: 4,
                spaceBetween: 72,
            },
            1280: {
              slidesPerView: 5,
              spaceBetween: 96,
            },
          },
          loop: true,
          autoplay: {
            delay: 0,
          },
          speed: 5000,
          freeMode: true,
          direction: 'horizontal',
          grabCursor: true,
          a11y: true,
        });
      }, 0);
    },
  };
};
